export default __webpack_public_path__ + "static/media/phylosophy.43f678af.png";